import { render, staticRenderFns } from "./premiumFirePlayer.vue?vue&type=template&id=75c64f70&scoped=true"
import script from "./premiumFirePlayer.vue?vue&type=script&lang=js"
export * from "./premiumFirePlayer.vue?vue&type=script&lang=js"
import style0 from "./commonTable.css?vue&type=style&index=0&id=75c64f70&prod&scoped=true&lang=css&external"
import style1 from "./premiumFirePlayer.vue?vue&type=style&index=1&id=75c64f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c64f70",
  null
  
)

export default component.exports